import { render, staticRenderFns } from "./BaseSearchForm.vue?vue&type=template&id=07a796b6&"
import script from "./BaseSearchForm.vue?vue&type=script&lang=js&"
export * from "./BaseSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports